// extracted by mini-css-extract-plugin
export default {"shipping_detail_container":"style_shipping_detail_container__cPLko","no_margin":"style_no_margin__U2HYo"};